import 'bootstrap'
import React from 'react'
import { createRoot } from "react-dom/client";

import { HashRouter } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material/styles'

import BusinessApp from './business_app'
import Menus from './menus'

// displays the business page with the menus and campaigns

const theme = createTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#6AAED9' // Amber framework primary colour
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      // light: will be calculated to contrast with palette.secondary.main
      main: '#F2AE2E'
      // dark: will be calculated from palette.secondary.main,
      // contrastText: will be calculated to contrast with palette.secondary.main
    }
    // error: will use the default color
  },
  components: {
    MuiAppBar: {
      color: '#F2AE2E',
      defaultProps: {
        enableColorOnDark: true,
      },
    },
  },
  status: {
    danger: '#d32f2f'
  }
})

document.addEventListener('DOMContentLoaded', function () {
 
  let container = document.getElementById("business-view");

  if (container) {
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<HashRouter>
      <ThemeProvider theme={theme}>
        <BusinessApp />
      </ThemeProvider>
    </HashRouter>);
  }

  container = document.getElementById('menus-view')
  if (container) {
      const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<HashRouter>
      <ThemeProvider theme={theme}>
        <Menus />
      </ThemeProvider>
    </HashRouter>);
  }

})
